export const ROLES = {
    Guest: "Guest",
    User: "User",
    Trade: "Trade",
    Staff: "Staff",
    Admin: "Admin",
}